export const CATEGORY_ANNOTATION_MAP = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H',
]

export const CATEGORY_NAME_LENGTH = 40
export const CATEGORY_OPTION_LENGTH = 150

export function getCategoryColorAt(palette, index) {
  if (!palette || !palette.length) return null
  return palette[index % palette.length]
}
